import { postRequestGateway } from './api.service'

export async function search(searchInput: string) {
  const endpoint = `/search/v1/search?q=${searchInput}`
  const res = await postRequestGateway(endpoint, {}, undefined)
  return res.data
}
